import { Color3 } from "@babylonjs/core/Maths/math.color";
import { CreateLines } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { CsgUtils } from "../CsgUtils";
import { ElementGeometry } from "./ElementGeometry";
import { RoomManager } from './../../RoomManager';
import { Util } from "../../utils/Util";
import { LengthProperty, PropertyValue, PropertyChangedResult } from "@egr/wcf/modules/core/prop";
export class PillarB extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mElementParams = {};
        this.mElementParams.privacyFilter = false;
        this.mElementParams.blindVisible = false;
        this.mElementParams.blindDepth = 0.07;
        this.mElementParams.blindOpeningAngle = 60;
        this.mElementParams.blindOpeningWidth = 0;
        this.mElementParams.ColumnCount = 2;
    }
    getType() {
        return ("PillarB");
    }
    setMesh(pMesh) {
        //
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.5;
        tParams.depth = 0.5;
        tParams.height = 2.6;
        tParams.floorOffset = 0.0;
        tParams.color = "#ffffff";
        return (tParams);
    }
    create2dGeometry(pParent) {
        this.setPoints();
        this.createPillar(pParent, true);
    }
    create3dGeometry(pParent) {
        this.createPillar(pParent);
    }
    getPropertyClasses() {
        return (Promise.resolve(this.mRoomManager.PropClasses));
    }
    getProperties() {
        let tProperties = new Array();
        //depth
        let tDepthProp = new LengthProperty(this.mRoomElement, PillarB.PROP_KEY_DEPTH, this.mRoomManager.resources.propertyDepth);
        tDepthProp.class = "base";
        tDepthProp.getValue = () => new PropertyValue(this.mRoomElement.depth);
        tDepthProp.setValue = (pValue) => {
            let tValue = LengthProperty.ConvertValueToNumber(pValue);
            if (tValue != null && this.mRoomElement.setDepth(tValue))
                return (Promise.resolve(PropertyChangedResult.Value));
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tDepthProp);
        return (tProperties);
    }
    serializeIOData() {
        return (this.mElementParams);
    }
    loadIOData(pData) {
        //
    }
    getEOXDescription(pDocument, pParentNode) {
        let tAttribsList = new Array();
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "structure_type", value: "Pillar_Box" });
        let tRoomElementNode = Util._xmlAddChildNode(pDocument, pParentNode, "object", "", tAttribsList);
        // define category
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "category", "Other", null);
        // position
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "x", value: this.mRoomElement.node.position.x.toString() });
        tAttribsList.push({ qualifiedName: "y", value: (this.mRoomElement.node.position.y).toString() });
        tAttribsList.push({ qualifiedName: "z", value: (-this.mRoomElement.node.position.z).toString() });
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "position", "", tAttribsList);
        // rotation
        let t3dRotation = this.mRoomElement.node.rotationQuaternion;
        tAttribsList = [];
        if (t3dRotation != null) {
            tAttribsList.push({ qualifiedName: "x", value: (-t3dRotation.x).toString() });
            tAttribsList.push({ qualifiedName: "y", value: (-t3dRotation.z).toString() });
            tAttribsList.push({ qualifiedName: "z", value: (-t3dRotation.y).toString() });
            tAttribsList.push({ qualifiedName: "w", value: (-t3dRotation.w).toString() });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "rotation", "", tAttribsList);
        }
        else {
            tAttribsList.push({ qualifiedName: "x", value: "0" });
            tAttribsList.push({ qualifiedName: "y", value: "0" });
            tAttribsList.push({ qualifiedName: "z", value: "0" });
            tAttribsList.push({ qualifiedName: "w", value: "1" });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "rotation", "", tAttribsList);
        }
        // width
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "width", this.mRoomElement.depth.toString(), null);
        // depth
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "depth", this.mRoomElement.width.toString(), null);
        // height
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "height", this.mRoomElement.height.toString(), null);
        // color
        tAttribsList = [];
        if (this.mRoomElement.color.trim() != '') {
            let tcolor = Util.hexToRGB(this.mRoomElement.color);
            tAttribsList.push({ qualifiedName: "r", value: tcolor.r.toString() });
            tAttribsList.push({ qualifiedName: "g", value: tcolor.g.toString() });
            tAttribsList.push({ qualifiedName: "b", value: tcolor.b.toString() });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "color", "", tAttribsList);
        }
    }
    setPoints() {
        this.mPoints = [];
        let tWH = this.mRoomElement.width * 0.5;
        let tDH = this.mRoomElement.depth * 0.5;
        this.mPoints.push(new Vector3(-tWH, 0, tDH));
        this.mPoints.push(new Vector3(-tWH, 0, -tDH));
        this.mPoints.push(new Vector3(tWH, 0, -tDH));
        this.mPoints.push(new Vector3(tWH, 0, tDH));
        this.mPoints.push(new Vector3(-tWH, 0, tDH));
    }
    createCSG(pParent) {
        let tPoints = new Array();
        for (let tP of this.mPoints) {
            tPoints.push(new CSG.Vector2D(tP.x, tP.z));
        }
        tPoints.pop();
        let tCAGshape = CAG.fromPointsNoCheck(tPoints);
        if (tCAGshape.isSelfIntersecting())
            return (null);
        let tCSG = Util.CAG2CSG(tCAGshape, this.mRoomElement.height);
        let tMeshes = CsgUtils.buildMeshes(tCSG, this.mScene);
        if (tMeshes == null)
            return (null);
        for (let tMesh of tMeshes) {
            tMesh.parent = pParent;
            //ShadowGenerator.disableMeshShadow((tMesh as Mesh));
            tMesh.material = this.mRoomElement.localMaterial;
            if (tMesh.material !== null) {
                tMesh.material.backFaceCulling = false;
            }
            if (this.mRoomElement.GroupMeshOpacity != 1) {
                tMesh.renderingGroupId = 1;
            }
            tMesh.visibility = this.mRoomElement.GroupMeshOpacity;
        }
        return (tMeshes[0]);
    }
    createPillar(pParent, pOutline = false) {
        this.createCSG(pParent);
        if (pOutline) {
            let tPoints = this.mPoints.slice();
            for (let tP of tPoints) {
                tP.y = this.mRoomElement.height + 0.01;
            }
            let tLines = CreateLines("", {
                points: tPoints,
                updatable: false,
                instance: null
            }, this.mScene);
            tLines.isPickable = false;
            tLines.intersectionThreshold = 0;
            tLines.color = Color3.Black();
            tLines.position.y = RoomManager.WALLOPENING_2D_LINE_HEIGHT;
            tLines.parent = pParent;
            this.prepare2dMesh(tLines);
        }
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
PillarB.PROP_KEY_DEPTH = "room:RoomElement:PillarB:depth";
PillarB.PROP_KEY_COLOR = "room:RoomElement:PillarB:color";
